<template>
      <div class="grid-skeleton-inner banner-grid-skeleton-inner mt-2">
            <div class="banner-skeleton"  v-for="index in 3" :key="index"></div>
      </div>
</template>

<script>
export default {};
</script>
